import { render, staticRenderFns } from "./next-conference.vue?vue&type=template&id=19f5f959&"
import script from "./next-conference.vue?vue&type=script&lang=js&"
export * from "./next-conference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports